export class Country {
    public countryCode: string;
    public countryDesc: string;
}
